import TeamManager from './TeamManager';

export default TeamManager;
